/**
 * /tenants/$slug/authentication/authenticators — layout of the Authenticators
 * tab: section nav, Find a setting and the section <Outlet/> (Approved
 * models, Add a model, Identity checks).
 */

import { createFileRoute } from "@tanstack/react-router";
import { queryKeys } from "@/lib/query-keys";
import { fetchAllowlist } from "@/features/authenticator-allowlist/queries";
import { fetchTenantDetail } from "@/features/tenants/queries";
import { AuthenticatorsLayout } from "@/features/authenticator-allowlist/pages/authenticators-layout";

export const Route = createFileRoute("/_authed/tenants/$slug/authentication/authenticators")({
  loader: async ({ context }) => {
    const tenant = context.tenant;
    await Promise.all([
      context.queryClient.ensureQueryData({
        queryKey: queryKeys.authenticatorAllowlist.list(tenant.id),
        queryFn: () => fetchAllowlist(tenant.id),
      }),
      // Whether passkey registration enforces the list depends on the
      // tenant's attestation preference. A prefetch, not an ensure: an admin
      // who cannot read the tenant detail still gets the list, with no claim
      // about passkeys.
      context.queryClient.prefetchQuery({
        queryKey: queryKeys.tenants.detail(tenant.slug),
        queryFn: () => fetchTenantDetail(tenant.id),
      }),
    ]);
  },
  component: AuthenticatorsLayout,
});
